<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Experience UNESCO’s Montenegro</h1>
    <div class='tourPic'>
      <img src='@/assets/cultours/tour5/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>The goal of this five-day tour is to introduce you to the most valuable cultural and natural heritage of Montenegro. </p>
            <p class='pasus'>It includes three localities listed as UNESCO world cultural and natural heritage sites: Kotor and its surroundings, Durmitor national park with Tara Canyon, medieval tombstones “stećci” as well as many other valuable sites protected by law as cultural and natural goods of great significance. Some of those are potential UNESCO protected regions in the future.</p>
            <p class='pasus'>Kotor will enchant us with its unique appearance and position – in the Bay of Boka embraced by high cliffs, with its meandering streets and squares, Durmitor massif will show us the spectacular relief shapes and beautiful glacial lakes while the mysterious medieval tombstones will tell as a story still considered an equation with many unknowns.</p>
            <p class='pasus'>We will have the opportunity to visit two national parks and their pearls – lakes of Skadar and Biogradsko. We will admire the ancient untouched forests and rapid creeks while the villages famous for its architecture and lifestyle will be telling us original stories revealing local tradition.</p>
            <p class='pasus'>Special moments of the tour are breathtaking viewpoints offering different scenery every day.  </p>
            <p class='pasus'>In physical terms, the tour is not demanding. We will make sure to walk only as much as much you want to, spend time at places you prefer but not disrupting the program we agreed upon.  </p>
            <p class='pasus'>You will spend time in regions known for its dairy delicacies, lake, sea and fresh water fish, olive but also for the homegrown fruits and vegetables. You will have the chance to taste famous Montenegrin ham and red wine, mead and brandy, as locals will always welcome you with kindness and pride.</p>
            <p class='pasus'>Cheers! </p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>
              Availability: June – October
            </p>
            <p class='pasus'>Group size: 1-7</p>
            <p class='pasus'>
              Departure from Podgorica airport, Tivat airport, or any other place in Montenegro
            </p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 6 days / 5 nights</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
                    <ul class='collapse itinerary_days' id='itinerary'>
          <li>
            <a data-toggle='collapse' href='#day1'> <h5 class='sub-titles'>Day 1 - Arrival day, National Park Skadar Lake visit, boat cruise, old village of Godinje & local vinery, Podgorica</h5></a>
            <div class='collapse' id='day1'>
              <p class='pasus'>After you land at Podgorica airport your driver/guide will meet you at the exit hall carrying a sign with your name. After a short introduction, you will head towards Virpazar and NP Skadar Lake. </p>
              <p class='pasus'>Virpazar is a small charming town on the lake’s shore, once an important marketplace and today the main starting point of boat excursions on the Skadar Lake and a home of probably the largest traditional festival in Montenegro dedicated to wine and bleak. Located on the confluence of two rivers, it is also where the antifascist battle in WW2 started.  </p>
              <p class='pasus'>National Park Skadar Lake is the largest in the Balkans shared between Montenegro and Albania. It is the area of the national park of the same name famous for its diverse flora and fauna. It is especially important as a bird habitat with about 280 species noted down so far.  </p>
              <p class='pasus'>Skadar Lake has been the inhabited area for millenniums encompassing some 50 islands with important cultural and historical monuments, monasteries and fortresses and old fishing villages of traditional architecture resting on its shores. </p>
              <p class='pasus'>Spending time near water and enjoying easy boat ride on a clam lake will be a perfect relaxation after your flight.  Surrounded by water lilies, reed and birds you will soon feel harmony with nature. </p>
              <p class='pasus'>Once we complete the boat ride, we will enjoy the views from the lake lookouts, pay a visit to Godinje village known for its unique architecture and wine and finally see a fortress dating back to the beginning of Ottoman occupation of this part of Montenegro. </p>
              <p class='pasus'>Evening hours are reserved for a walking tour through the heart of Podgorica, the capital of Montenegro. We will visit the old parts of town, the confluence of two rivers not far from the city center, the Gorica Hill after which the town got its name, the old church of St. George… </p>
              <p class='pasus'></p>
              <p class='pasus'>Accommodation – hotel 4* Podgorica </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 1.3 hours</p>
                <p> <i class='fas fa-route'></i> 70 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour5/day1.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day2'> <h5 class='sub-titles'>Day 2 - Through the old royal capital Cetinje and over Lovćen mountain to UNESCO-protected Kotor and its beautiful surroundings</h5></a>
            <div class='collapse' id='day2'>
              <p class='pasus'>On the second day of our tour you will get to know the gems of Montenegrin cultural offer but also fantastic natural areas and viewpoints.  </p>
              <p class='pasus'>Cetinje was the capital of Montenegro until 1946 representing the center of free Montenegro during the powerful Ottoman Empire presence in the Balkans. It is the cradle of independent Montenegrin state, the town of museums and faculties of arts, the center of Montenegrin spirituality.  </p>
              <p class='pasus'>National Park Lovcen is known for its biodiversity, cultural heritage and amazing observation points onto the area of Boka Bay. Lovcen Mountain for Montenegrins is the same as Olimp for Greeks with the second highest peak being a home to the highest mausoleum in Europe, dedicated to Petar Petrovic Njegos II, ruler, poet and philosopher.   </p>
              <p class='pasus'>A crown of the second day of our tour is a visit to Kotor old town, the pearl of Venetian architecture, listed as UNESCO world cultural heritage site in 1980. We will take a stroll down its narrow streets and squares, take a look into the old churched and cathedrals and walk its walls.  </p>
              <p class='pasus'>Not far away from Kotor is another UNESCO protected area, a beautiful baroque tiny town of Perast known for its maritime tradition and not far off - two islands with old catholic churches. </p>
              <p class='pasus'>We are back in Podgorica in the evening.  </p>
              <p class='pasus'>Accommodation- hotel 4* Podgorica </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 3.5 hours</p>
                <p> <i class='fas fa-route'></i> 200 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour5/day2.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day3'><h5 class='sub-titles'>Day 3 - Ostrog Monastery, geological miracles of Durmitor NP, view on Piva Lake & Canyon</h5></a>
            <div class='collapse' id='day3'>
              <p class='pasus'>On this day we will ascend from 50 to 1500 meters above sea level in only a couple of hours. We shall start from Montenegro’s largest urban center and finish surrounded by a remote, high and magnificent massif of Montenegro’s most famous mountain Durmitor. </p>
              <p class='pasus'>One of the most significant Montenegrin monasteries and surely the most famous and spectacular is located some 45 km away from Podgorica at 900 meters above sea level, under the steep cliff of Ostrog Mountain (after which it was named). The monastery of impressive appearance was founded in mid-17th century by a monk and a superior of one of the eparchy of former Serbian Orthodox Church – Vasilije, whose cult has vastly spread so the present-day monastery stands as one of the most visited Orthodox spiritual centers worldwide. It is visited by people of different religions.   We will find out more about the role of church in traditional Montenegro’s society, St Vasilije cult and fresco painting. </p>
              <p class='pasus'>On our way to Durmitor Mountain we won’t miss the opportunity to go to the observation points providing a stunning view on the Piva River Canyon and Piva Lake whilst we will also have the chance to taste some of traditional specialties of Montenegrin mountain region.  </p>
              <p class='pasus'>Durmitor massif is well known for its geological characteristics and natural beauty owing to which it is declared national park and along with Tara River Canyon listed as UNESCO site.  </p>
              <p class='pasus'>The mountain is famous for seasonal cattle settlements known as katuns where during the summer stockbreeders come with their cows and sheep staying until first cold days and snow.  </p>
              <p class='pasus'>If weather allows we shall make our way deeper into the mountain.  </p>
              <p class='pasus'>We will finish the day and spend the night in Zabljak, a small town sitting at the highest elevation in the Balkans. </p>
              <p class='pasus'>Accommodation- Hotel 4* in Zabljak or high level private apartments </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 3.5 hours</p>
                <p> <i class='fas fa-route'></i> 150 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour5/day3.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day4'><h5 class='sub-titles'>Day 4 - Zabljak and its magnificent surroundings, Tara Canyon viewpoint, stećci- mysterious medieval tombstones and glacier lakes (mountain eyes)</h5></a>
            <div class='collapse' id='day4'>
              <p class='pasus'>The whole fourth day of our tour is reserved for exploring national park Durmitor, a UNESCO world heritage site and its surroundings. We will start from its pearl – Black Lake, take a walk around the lake enjoying the scenery.  </p>
              <p class='pasus'>Our next stop will be Tara Canyon viewpoint. Tara canyon is known as the deepest in Europe and among the deepest in the world. We will visit the lookout offering a view on its deepest part (1330m), while surrounded by a beautiful and old coniferous forest.   </p>
              <p class='pasus'>On this day we will pay a visit to a locality with medieval tombstones (stećci), recently protected by UNESCO, called Greek graveyards among locals and hear the story about their origins and mysteries. </p>
              <p class='pasus'>In the close vicinity of medieval tombstones there two beautiful glacial lakes, Vrazje & Riblje. Durmitor massif features 18 glacial lakes known as “mountain eyes” each one of which is a paradise for the eyes and for the bravest – places of summer refreshment and bathe. Of course, there are local legends to add a dose of mystery and warning to this outstanding natural environment.  </p>
              <p class='pasus'>Accommodation- Hotel 4* in Zabljak or high level private apartments </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 1 hour</p>
                <p> <i class='fas fa-route'></i> 30 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour5/day4.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day5'><h5 class='sub-titles'>Day 5 - Magnificent Tara Bridge and Canyon, Biogardska gora NP – old forest and glacier lake, Monastery Moraca & Moraca canyon</h5></a>
            <div class='collapse' id='day5'>
              <p class='pasus'>It is time to move further and in couple of hours enjoy the beauty of Tara Canyon and its pearls. We will admire the grandiose bridge over Tara and the surroundings, make our way down to the very river and its rapids, try the zip-line if wanted so…  </p>
              <p class='pasus'>In the canyon there is a strictly protected natural reserve of black pine forest. The size and appearance of these giants, guardians of the canyon, will impress you. Some of them are more than 400 years old. </p>
              <p class='pasus'>Another national park is included in our program on the fifth day. National Park Biogradska Gora is famous for its lake as well as for one of the largest remaining European virgin forests. A very rich flora is one of its main characteristics. We will take a walk around the lake, take a canoe ride if wanted so and embrace 3 or 4 centuries old trunks of impressive size.  </p>
              <p class='pasus'>On this day on our way is one of the most significant Montenegrin monasteries - Moraca monastery, located just next to the Moraca River, and contains some of the most beautiful icons and frescoes not just in Montenegro but in the Balkans. There is a great history behind this 8 centuries old religious place and it is one of the most visited monasteries in Montenegro. </p>
              <p class='pasus'>The spectacular Moraca river canyon begins in just a few minutes from the monastery. It’s about 30 km long and up to 1000 m deep, famous for its steep cliffs. Our stop will be in the middle of the canyon with a view on clear and green Moraca River. </p>
              <p class='pasus'> </p>
              <p class='pasus'>Accommodation- 4 star hotel in Podgorica </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 3 hours</p>
                <p> <i class='fas fa-route'></i> 170 km</p>
              </div>
              <img class='daypic' src='@/assets/cultours/tour5/day5.jpg'>
            </div>
            <br/>
          </li>
          <li>
            <a data-toggle='collapse' href='#day6'><h5 class='sub-titles'>Day 6 -  Departure day</h5></a>
            <div class='collapse' id='day6'>
              <p class='pasus'>Your last day in the morning you’ll have breakfast as usual. Then our driver will pick up your luggage and after breakfast we will drive you directly to the airport</p>
            </div>
          </li>
          </ul>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'>
            <h4 class='titles'>Prices (based on the number of people in your group):</h4>
          </a>
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>2 persons – 1350 EUR p/person</li>
              <li class='pasus'>4 persons – 1000 EUR p/person</li>
              <li class='pasus'>6 persons – 900 EUR p/person</li>
              <li class='pasus'>For bigger groups on request</li>
              <li class='pasus'>Single room supplement: 150 EUR.</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Accommodation for all nights</li>
              <li class='pasus'>Transportation (van/car)</li>
              <li class='pasus'>Breakfast and dinner for all days</li>
              <li class='pasus'>Bottle of water (0,5l) for each day</li>
              <li class='pasus'>Transfer to the airport on the last day</li>
              <li class='pasus'>Entrance fees for everything included in the program</li>
              <li class='pasus'>Our assistance 24/7</li>
              <li class='pasus'>Licensed tour guide</li>
              <li class='pasus'>A map of Montenegro</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
            <a data-toggle='collapse' href='#notincluded'> <h4 class='titles'>Not included in price</h4></a>
            <div class='collapse' id='notincluded'>
              <ul class='square'>
                <li class='pasus'>Optional activities</li>
                <li class='pasus'>Lunch, drinks and tips</li>
                <li class='pasus'>Personal expenses</li>
              </ul>
            </div>
          </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>We recommend that you always carry with you a light jacket, a cap, sunglasses and a swimming suit. </li>
              <li class='pasus'>The altitude difference we make is around 1850 meters. We start at 5 meters above sea level and the highest point we reach is at 1900 meters above sea level.</li>
              <li class='pasus'>Prices at restaurants and cafes are very affordable and we will always recommend those places we have already checked out and which stand out as the best choices in the specific area.</li>
              <li class='pasus'>The currency is euro </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Zip line</li>
              <li class='pasus'>Horse riding</li>
              <li class='pasus'>Rafting</li>
              <li class='pasus'>Kayak or canoe on the glacial lakes</li>
              <li class='pasus'>Cable car in Durmitor NP</li>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>Itinerary changes during the tour can be agreed (do not affect the price)</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/cultours/tour5/01.jpg'),
          thumbnail: require('@/assets/cultours/tour5/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/02.jpg'),
          thumbnail: require('@/assets/cultours/tour5/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/03.jpg'),
          thumbnail: require('@/assets/cultours/tour5/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/04.jpg'),
          thumbnail: require('@/assets/cultours/tour5/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/05.jpg'),
          thumbnail: require('@/assets/cultours/tour5/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/06.jpg'),
          thumbnail: require('@/assets/cultours/tour5/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/07.jpg'),
          thumbnail: require('@/assets/cultours/tour5/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/08.jpg'),
          thumbnail: require('@/assets/cultours/tour5/08.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/09.jpg'),
          thumbnail: require('@/assets/cultours/tour5/09.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/10.jpg'),
          thumbnail: require('@/assets/cultours/tour5/10.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/11.jpg'),
          thumbnail: require('@/assets/cultours/tour5/11.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/12.jpg'),
          thumbnail: require('@/assets/cultours/tour5/12.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/13.jpg'),
          thumbnail: require('@/assets/cultours/tour5/13.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/14.jpg'),
          thumbnail: require('@/assets/cultours/tour5/14.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour5/15.jpg'),
          thumbnail: require('@/assets/cultours/tour5/15.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/CT5_UnescoHeritage.vue